module.exports = __webpack_public_path__ + "img/history_log.1107342b.svg";